export default "__VITE_ASSET__d62e7b18__"